import { Base_Url, getToken } from "../Utils/Const";
import axios from "axios";

export async function Login_Api(Credential) {
  try {
    const response = await axios.post(
      Base_Url + "admin/adminLogin",
      Credential
    );

    // window.location.href = "/";
    return response;
  } catch (error) {
    return error.response.data;
  }
}
export async function ABC(Credential) {
  try {
    const response = await axios.post(Base_Url + "login", Credential);
    return response.data;
  } catch (error) {
    throw error;
  }
}
//This Are the  All Graph data  Api

export async function All_Graph_Data(
  month,
  year,
  interval,
  startDate,
  endDate
) {
  try {
    if (month === undefined || year === undefined || interval === undefined) {
      throw new Error("Month, year, or interval is undefined.");
    }

    const response = await axios.post(
      Base_Url + "admin/userGraph",
      {
        year: year.toString(),
        month: month.toString(),
        interval: interval,
        startDate: startDate,
        endDate: endDate,
      },
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}

//This Are the  User Management api  include UserTable,User Deleted,User Disable And user Search value
export async function USER_TABLE_DATA(
  searchValue,
  sort,
  order,
  page,
  rowsPerPage,
  isDeleted,
  duration,
  subScription,
  SubscriptionName
) {
  try {
    const response = await axios.post(
      Base_Url + "admin/userList",
      {
        sort: sort,
        order: order,
        search: searchValue,
        duration: duration,
        page: page + 1,
        limit: rowsPerPage,
        isActive: subScription,
        isDeleted: isDeleted,
        subscriptionName: SubscriptionName,
      },
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
}
export const deleteUser = async (userId) => {
  try {
    const requestData = {
      id: userId,
    };

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: getToken(),
    };
    const response = await axios.delete(Base_Url + "users/deleteUser", {
      headers: requestHeaders,
      data: requestData,
    });

    return response;
  } catch (error) {
    console.log(error, "deleteUserError");

    throw error;
  }
};
export const disableUser = async (userId) => {
  try {
    const requestData = {
      _id: userId,
    };

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: getToken(),
    };

    const response = await axios.post(
      Base_Url + "admin/disableUser",
      requestData,
      {
        headers: requestHeaders,
      }
    );

    return response;
  } catch (error) {
    console.log(error, "disableUser");
    throw error;
  }
};
export const enableUser = async (userId) => {
  try {
    const requestData = {
      _id: userId,
    };

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: getToken(),
    };

    const response = await axios.post(
      Base_Url + "admin/enableUser",
      requestData,
      {
        headers: requestHeaders,
      }
    );

    return response;
  } catch (error) {
    console.log(error, "enableUser");
    throw error;
  }
};

//This Are the Cleanear management Api include disableCleaner
export const deleteCleaner = async (cleanerId) => {
  try {
    const requestData = {
      id: cleanerId,
    };

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: getToken(),
    };
    const response = await axios.delete(Base_Url + "admin/deleteCleaner", {
      headers: requestHeaders,
      data: requestData,
    });

    return response;
  } catch (error) {
    console.log(error, "deleteUserError");

    throw error;
  }
};
export const disableCleaner = async (cleanerId) => {
  try {
    const requestData = {
      _id: cleanerId,
    };

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: getToken(),
    };

    const response = await axios.post(
      Base_Url + "admin/disableCleaner",
      requestData,
      {
        headers: requestHeaders,
      }
    );

    return response;
  } catch (error) {
    console.log(error, "disableUser");
    throw error;
  }
};
export const enableCleaner = async (cleanerId) => {
  try {
    const requestData = {
      _id: cleanerId,
    };

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: getToken(),
    };

    const response = await axios.post(
      Base_Url + "admin/enableCleaner",
      requestData,
      {
        headers: requestHeaders,
      }
    );

    return response;
  } catch (error) {
    console.log(error, "enableUser");
    throw error;
  }
};

export async function CLEANER_TABLE_DATA(
  searchValue,
  page,
  rowsPerPage,
  sort,
  order,
  duration,
  subScription,
  isDeleted
) {
  try {
    const response = await axios.post(
      Base_Url + "admin/cleanerList",
      {
        sort: sort,
        order: order,
        search: searchValue,
        page: page + 1,
        duration: duration,
        limit: rowsPerPage,
        isActive: subScription,
        isDeleted: isDeleted,
      },
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
}
// Here Are The Property Management Api
export async function PROPERTY_TABLE_DATA(
  searchValue,
  page,
  rowsPerPage,
  sort,
  order,
  duration,
  subScription
) {
  try {
    const response = await axios.post(
      Base_Url + "admin/propertyList",
      {
        sort: sort,
        order: order,
        search: searchValue,
        page: page + 1,
        duration: duration,
        limit: rowsPerPage,
        isActive: subScription,
      },
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export const deleteProperty = async (propertyId) => {
  try {
    const requestData = {
      id: propertyId,
    };

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: getToken(),
    };
    const response = await axios.delete(Base_Url + "admin/deleteProperty", {
      headers: requestHeaders,
      data: requestData,
    });

    return response;
  } catch (error) {
    console.log(error, "deleteUserError");

    throw error;
  }
};

export async function Subscription_TABLE_DATA(
  searchValue,
  sort,
  order,
  page,
  rowsPerPage,
  duration,
  subscriptionName
) {
  try {
    const response = await axios.post(
      Base_Url + "admin/subscriptionList",
      {
        sort: sort,
        order: order,
        search: searchValue,
        page: page + 1,
        limit: rowsPerPage,
        duration: duration,
        subscriptionName: subscriptionName,
      },
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

//Here Are The Subscription Management Inside  -->>>> Create  Subscription Api
export async function Create_Subscription(subscriptionData) {
  try {
    const response = await axios.post(
      Base_Url + "admin/createProduct",
      {
        name: subscriptionData.name,
        amount: subscriptionData.amount,
        currency: subscriptionData.currency || "usd",
        description: subscriptionData.description || "",
        features: subscriptionData.features || [],
      },
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Create Subscription API Error:", error);
    throw error;
  }
}

//Here Are the Setting Api  Get Api
export async function Get_Subscription_Api() {
  try {
    const response = await axios.get(Base_Url + "admin/userSubscriptionPlan", {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function Get_Subscription_Plan_Details() {
  try {
    const response = await axios.get(Base_Url + "admin/getProduct", {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

//Here Are the Profile Api  Get Api
export async function Get_Profile_Api() {
  try {
    const response = await axios.get(Base_Url + "admin/getProfile", {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

//Here Are the Payment settings Api  Get Api
export async function Get_Payment_Setting_Api() {
  try {
    const response = await axios.get(Base_Url + "admin/getPaymentSetting", {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

//Here Are the  Notification  Get Api
export async function Get_Admin_Notifications_Api(duration = "7days") {
  try {
    const response = await axios.get(
      Base_Url + `admin/getAdminNotification?duration=${duration}`,
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

// here Are the   Product Show means idhar muhje  Plan ke   Subscription Show Honge
export async function Get_UserPlanData_Api() {
  try {
    const response = await axios.get(Base_Url + "admin/userPlanData", {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

// Here Are The Patch Api Of Edit Create Subscription
export async function editProductApi(
  _id,
  duration,
  amount,
  subscriptiondetail
) {
  try {
    const response = await axios.patch(
      `${Base_Url}admin/editProduct`,
      {
        id: _id,
        duration: duration,
        amount: amount,
        features: subscriptiondetail,
      },
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
